<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3>{{multiLanguage.relationshipListReport}}</h3>
      </div>
      <div class="panel" 
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.5)">
        <itable
          :thData="thTitle"
          :trData="trData"
          :page="page"
          :multiLanguage="multiLanguage"
          :seekDropdown="seekDropdown"
          :selPage="selPage"
          :filterData='filterData'
          @tableChange="tableAjax"
          @seek="tableAjax"
          @downLoadExcelFn="excelDown"
          @filterFn="filterFn"
        >
        </itable>
      </div>
    </div>
  </div>
</template>

<script>
  import { Api } from 'api/commissionEnv'
  import { URL_PRERELATION } from 'api/commissionApi'
  import itable from "./relationShipTable"
  var api = new Api()
  export default {
    mixins: [
      require("common/mixin/base.js").base({multiLanguage:"commissionTable"})
    ],
    props: ['curArea'],
    components: {
        itable
    },
    data () { 
      return {
        filterDatainit:[],
        loading: '',
        filterVal: '',
        thTitle: ["TD","CL","IB","SL","M","O","R","N","C","UN"],
        trData: [], //  表格tr数据
        seekDropdown: {  // 搜索选项
          seekStr: ""  // 搜索内容
        },
        filterStr: '',
        page: {  // 分页
          active: 1,  
          pageLeng: 0,
          offset: 0  // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
        },
        selPage: {  // 配合分页的显示col数目选择
          list: [5, 10, 25, 50],  // 选择显示col数目
          active: localStorage.pageMaxIndex,  // 当前list的坐标
          limit: [5, 10, 25, 50][localStorage.pageMaxIndex]  // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值 
        },
        filterData:{}
      }
    },
      mounted () {
        this.seekDropdown && (this.seekDropdown.seekStr = "")
      },
      computed: {
      },
      methods: {
        excelDown (showName) {
          this.$http.get(api.getUrl20(this.curArea,URL_PRERELATION),{params: {pageNum:0,pageSize:this.page.pageLeng,id:this.seekDropdown.seekStr}}).then((res) => {
            if (res.data.code == 200 && res.data.data.data.length>0 && res.data.msg == 'OK') {
              let excelData = res.data.data.data
              let data = res.data.data
              let set = new Set()
                for(let val of excelData) {
                  for(let v of Object.keys(val)) set.add(v)
                }
              let excelTH = Array.from(set)
              this.getMax('IB',excelData,data.IB_ID,)
              this.getMax('SL',excelData,data.SL_ID,)
              this.getMax('M',excelData,data.M_ID,)
              this.getMax('O',excelData,data.O_ID);
              this.getMax('R',excelData,data.R_ID);
              this.getMax('N',excelData,data.N_ID);
              this.getMax('C',excelData,data.C_ID);
              this.getMax('UN',excelData,data.UN_ID);

              this.getTH('IB','UPIB',excelTH,excelData)
              this.getTH('SL','UPSL',excelTH,excelData)
              this.getTH('M','UPM',excelTH,excelData)
              this.getTH('O','UPO',excelTH,excelData);
              this.getTH('R','UPR',excelTH,excelData);
              this.getTH('N','UPN',excelTH,excelData);
              this.getTH('C','UPC',excelTH,excelData);
              this.getTH('UN','UPUN',excelTH,excelData);
              this.export2Excel(excelTH,excelData,showName)
            }
          })
        },
        export2Excel (excelTH,excelData,showName) {
            let thRes = []
            let trRes = []
            for (let item of excelTH) thRes.push(this.multiLanguage.th.loginType.roleType[item])
            excelData.forEach(item => {
              let tem = {}
              for (let key in item) {
                if (key == 'TD' || "CL" == key) {
                  if(Object.keys(item[key]).length>0){
                    tem[key] = item[key].id+ (showName ? ' - ' + (item[key].name ? item[key].name: '') : '');
                  }else{
                    tem[key] = ' - ';
                  }
                }
                else {
                  if (item[key].length == 0) tem[key] = ' - '
                  else if (item[key].length == 1) tem[key] = Object.keys(item[key][0]).length>0 ? item[key][0].id + (showName ? ' - ' + (item[key][0].name ? item[key][0].name: '') : '') : ' - '
                  else {
                    tem[key] = Object.keys(item[key][0]).length>0 ? item[key][0].id+ (showName ? ' - ' + (item[key][0].name ? item[key][0].name: '') : '') : ' - '
                    for (let i = 1; i<item[key].length; i++) {
                      tem['UP'+key+i] = Object.keys(item[key][i]).length>0 ? item[key][i].id + (showName ? '-' + (item[key][i].name ? item[key][i].name: '') : '') : ' - '
                    }
                  }
                }
              }
              trRes.push(tem)
            })
            require.ensure([], () => {
              const { export_json_to_excel } = require('@/vendor/Export2Excel')
              const tHeader = thRes
              const filterVal = excelTH
              const list = trRes
              const data = this.formatJson(filterVal, list)
              let curArea = JSON.parse(sessionStorage.getItem('currentArea'))
              export_json_to_excel(tHeader, data, curArea.value + ' ' + this.multiLanguage.relationshipListReport)
            })
        },
        formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => v[j]))
        },
        filterFn () {
          this.loading = true
          let pageNum = this.page.active-1
          let pageSize = this.selPage.limit
          let id = this.filterVal
          this.$http.get(api.getUrl20(this.curArea,URL_PRERELATION),{params:{pageNum,pageSize,id}}).then((res) => {
            if (res.data.code == 200 && res.data.data.data.length>0 && res.data.msg == 'OK'){
              this.trData = res.data.data.data
              this.page.pageLeng = res.data.data.count
              let set = new Set()
                for(let val of this.trData) {
                  for(let v of Object.keys(val)) set.add(v)
                }
                this.thTitle = Array.from(set)
                this.getMax('IB',this.trData,this.filterDatainit.IB_ID)
                this.getMax('SL',this.trData,this.filterDatainit.SL_ID)
                this.getMax('M',this.trData,this.filterDatainit.M_ID)
                this.getMax('O',this.trData,this.filterDatainit.O_ID);
                this.getMax('R',this.trData,this.filterDatainit.R_ID);
                this.getMax('N',this.trData,this.filterDatainit.N_ID);
                this.getMax('C',this.trData,this.filterDatainit.C_ID);
                this.getMax('UN',this.trData,this.filterDatainit.UN_ID);

                this.getTH('IB','UPIB',this.thTitle,this.trData)
                this.getTH('SL','UPSL',this.thTitle,this.trData)
                this.getTH('M','UPM',this.thTitle,this.trData)
                this.getTH('O','UPO',this.thTitle,this.trData);
                this.getTH('R','UPR',this.thTitle,this.trData);
                this.getTH('N','UPN',this.thTitle,this.trData);
                this.getTH('C','UPC',this.thTitle,this.trData);
                this.getTH('UN','UPUN',this.thTitle,this.trData);

                this.loading = false
            }else {
              this.loading = false
            }
          })
        },
        tableAjax() {
          this.loading = true 
          let pageNum = this.page.active-1
          let pageSize = this.selPage.limit
          let id = this.seekDropdown.seekStr
          this.$http(api.getUrl20(this.curArea,URL_PRERELATION),{
              params: {pageNum,pageSize,id}
          }).then((res) => {
            if (res.data.code == 200 && res.data.data.data && res.data.msg == 'OK'){
                this.trData = res.data.data.data
                this.page.pageLeng = res.data.data.count
                this.filterVal = ''
                // 获取筛选项
                let data = res.data.data
                this.filterDatainit = data
                this.filterData.CL = data.CL_ID
                this.filterData.IB = data.IB_ID[0]
                for(var i=1;i<data.IB_ID.length;i++) this.filterData['UPIB'+i] = data.IB_ID[i]
                this.filterData.SL = data.SL_ID[0]
                for(var i=1;i<data.SL_ID.length;i++) this.filterData['UPSL'+i] = data.SL_ID[i]
                this.filterData.M = data.M_ID[0]
                for(var i=1;i<data.M_ID.length;i++) this.filterData['UPM'+i] = data.M_ID[i]
                for(var i=1;i<data.O_ID.length;i++) {
                  this.filterData['UPO'+i] = data.O_ID[i];
                }
                for(var i=1;i<data.R_ID.length;i++) {
                  this.filterData['UPR'+i] = data.R_ID[i];
                }
                for(var i=1;i<data.N_ID.length;i++) {
                  this.filterData['UPN'+i] = data.N_ID[i];
                }
                for(var i=1;i<data.C_ID.length;i++) {
                  this.filterData['UPC'+i] = data.C_ID[i];
                }
                for(var i=1;i<data.UN_ID.length;i++) {
                  this.filterData['UPUN'+i] = data.UN_ID[i];
                }
                // 获取筛选项结束
                let set = new Set()
                for(let val of this.trData) {
                  for(let v of Object.keys(val)) set.add(v)
                }
                this.thTitle = Array.from(set)
                this.getMax('IB',this.trData,data.IB_ID)
                this.getMax('SL',this.trData,data.SL_ID)
                this.getMax('M',this.trData,data.M_ID)
                this.getMax('O',this.trData,data.O_ID);
                this.getMax('R',this.trData,data.R_ID);
                this.getMax('N',this.trData,data.N_ID);
                this.getMax('C',this.trData,data.C_ID);
                this.getMax('UN',this.trData,data.UN_ID);
                
                this.getTH('IB','UPIB',this.thTitle,this.trData)
                this.getTH('SL','UPSL',this.thTitle,this.trData)
                this.getTH('M','UPM',this.thTitle,this.trData)
                this.getTH('O','UPO',this.thTitle,this.trData);
                this.getTH('R','UPR',this.thTitle,this.trData);
                this.getTH('N','UPN',this.thTitle,this.trData);
                this.getTH('C','UPC',this.thTitle,this.trData);
                this.getTH('UN','UPUN',this.thTitle,this.trData);

                this.loading = false
            }else {
              this.trData = []
              this.filterData = {}
              this.loading = false
              this.page.pageLeng = 0
            }  
          })
          
        },
        getTH(key,newTH,thData,trData) {
          let code = thData.indexOf(key)
          if (trData.length>0){
            if (trData[0][key].length > 1){
                for(let i=trData[0][key].length-1;i>=1;i--){
                  thData.splice(code+1,0,newTH+i)
              }
            }
          }
        },
        getMax(key,data,dataArr){
          let maxLen = dataArr.length 
          // let maxLen = 0
          // for (let item of data) {
          //   if (item[key]){
          //     if (item[key].length > maxLen) maxLen = item[key].length
          //   }
          // }
          for (let item of data) {
            if(item[key]){
              let more = maxLen - item[key].length
              while (more-- > 0){ item[key].push({})}
            }
          }
        }
      },
      watch: {
        curArea () {
          this.page.offset = 0
          this.tableAjax()
        }
      }
  }
</script>
<style lang="scss" scoped>
    .tabs{
        padding: 0 25px;
    }
    .title-box{
      border: 1px solid #3F51B5;
      background: #3F51B5;
      padding: 0 20px;
      color: #fff;
      border-radius: 5px 5px 0 0;
    }
</style>




// WEBPACK FOOTER //
// relationshipListReport.vue?d1a632c2